<page-content>
  <ng-container *ngIf="myPackage?.ibexTouch">
    <div class="col">
      <mat-card appearance="outlined">
        <mat-card-title>{{'packages.ibexsmart.general' | translate}}</mat-card-title>
        <ng-container *ngFor="let key of generalFieldNames">
          <smart-input *ngIf="key !== 'matchIds'" [(model)]="myPackage" [hasTrash]="true" [key]="key" hintTranslationPrefix="packages.ibextouch.hints"
                       jsonPointerKey="/ibexTouch" translationPrefix="packages.ibextouch"></smart-input>
        </ng-container>
      </mat-card>
    </div>
    <div class="col">
      <mat-card appearance="outlined">
        <mat-card-title>{{'packages.ibexsmart.styling' | translate}}</mat-card-title>
        <div *ngFor="let key of styleFieldNames" class="input-container">
          <smart-input *ngIf="key !== 'matchIds'" [(model)]="myPackage" [hasTrash]="true" [key]="key" hintTranslationPrefix="packages.ibextouch.hints"
                       jsonPointerKey="/ibexTouch" translationPrefix="packages.ibextouch"></smart-input>
          <button *ngIf="key === 'customCss' && myPackage.ibexTouch.customCss" class="ibexfusion-icon-button edit" mat-icon-button
                  (click)="editCodeSnippet(myPackage.ibexTouch.customCss)"><mat-icon>edit</mat-icon></button>
        </div>
      </mat-card>
    </div>
  </ng-container>
  <div class="button-right-container">
    <button (click)="save()" class="ibexfusion-raised-button" mat-button>{{'general.save' | translate}}</button>
  </div>
</page-content>
